/**
 * This is the memword routes configuration.
 * Only configure routes in this file.
 * @memberOf memword Module
 * @namespace memword Routes
 */
import memwordTemplate from './memword.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf memword Module.memword Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the memword state and assign the template and controller. */
    $stateProvider
		.state('login.memword', {
			url: '/memword',
			template: memwordTemplate,
			controller: 'memwordController',
			controllerAs: 'memwordController'
		});
}

export default config;



// WEBPACK FOOTER //
// ./src/login/memword/memword.route.js